module.exports = __webpack_public_path__ + "static/media/logo-patriot.01874cc4.svg";